import React from 'react'
import { Typography } from 'modules/core/components'

const ContactName = ({ name }) => {
  return <Typography.Body>{name}</Typography.Body>
}
export default ContactName
